<template>
  <div class="content" style="padding-top: 55px">
    <!-- <title-bar :title="$lang.common_txt63"></title-bar> -->
    <van-nav-bar
      :title="$lang.common_txt63"
      :border="false"
      fixed
      z-index="99999"
      @click-left="onClickLeft"
    >
      <template #left>
        <van-icon name="arrow-left" size="20" color="#ffffff" />
      </template>
    </van-nav-bar>
    <div class="cot-Search">
      <van-field
        v-model="gameValue"
        :placeholder="$lang.common_txt144"
        class="custom-field"
        style="border: none !important"
      >
        <template #right-icon>
          <img src="../../../assets/img/common/ssk_com.png" width="18" />
        </template>
      </van-field>
    </div>
    <div v-if="categoryReadError" class="category-read-error">
      {{ categoryReadError }}
    </div>
    <div v-if="dataList.length > 0" class="cot-cont">
      <div class="cot-cont-r">
        <div class="cot-cont-rt">
          <div
            class="cot-cont-rti"
            v-for="(item2, index2) in ['All', 'Favorite']"
            :key="index2"
            :class="{ 'active-select2': index2 === selectIndex2 }"
            @click="getSelect2(index2)"
          >
            {{ item2 }}
          </div>
        </div>
        <div
          v-if="selectIndex2 === 0"
          class="cot-cont-rb d-flex-s"
          ref="targetElement"
        >
          <div
            v-for="(item3, index) in allGames"
            :key="index"
            class="cot-cont-rbi"
            @click="goToGame(item3.gid, item3)"
          >
            <van-image :src="item3.gameIcon" width="100%" radius="13" lazy-load>
              <template v-slot:loading>
                <van-loading size="20" color="#ff5a1f" vertical />
              </template>
            </van-image>
            <div v-if="item3.gameIcon">
              <img
                v-if="!isFavorite(item3)"
                @click.stop="toggleFavorite(item3)"
                src="../../../assets/img/common/scyx.png"
                width="20"
                style="position: absolute; right: 5px; top: 5px"
              />
              <img
                v-if="isFavorite(item3)"
                @click.stop="toggleFavorite(item3)"
                src="../../../assets/img/common/scyx-a.png"
                width="20"
                style="position: absolute; right: 5px; top: 5px"
              />
              <div
                v-if="
                  dataList[selectIndex] &&
                  dataList[selectIndex].types &&
                  dataList[selectIndex].types[selectIndex2] &&
                  dataList[selectIndex].types[selectIndex2].showName === 'yes'
                "
                style="
                  position: absolute;
                  text-align: center;
                  bottom: 5px;
                  width: 100%;
                  color: #ffffff !important;
                "
              >
                {{ item3.gameName }}
              </div>
            </div>
          </div>
          <!-- 没有数据时显示 -->
          <div
            class="t-c"
            style="margin-top: 20vh"
            v-if="allGames.length === 0"
          >
            <img src="../../../assets/img/common/img_no_data.png" width="90%" />
            <p class="font-color f-t-15 f-w">{{ $lang.common_txt145 }}</p>
          </div>
          <!-- 添加伪元素来模拟最后一个元素与前一个元素之间的间隔 -->
          <div class="spacer"></div>
        </div>
        <div
          v-if="selectIndex2 === 1"
          class="cot-cont-rb d-flex-s"
          ref="targetElement"
        >
          <div
            v-for="(item3, index) in favariteGames"
            :key="index"
            class="cot-cont-rbi"
            @click="goToGame(item3.gid, item3)"
          >
            <van-image :src="item3.gameIcon" width="100%" radius="13" lazy-load>
              <template v-slot:loading>
                <van-loading size="20" color="#ff5a1f" vertical />
              </template>
            </van-image>
            <div v-if="item3.gameIcon">
              <img
                v-if="!isFavorite(item3)"
                @click.stop="toggleFavorite(item3)"
                src="../../../assets/img/common/scyx.png"
                width="20"
                style="position: absolute; right: 5px; top: 5px"
              />
              <img
                v-if="isFavorite(item3)"
                @click.stop="toggleFavorite(item3)"
                src="../../../assets/img/common/scyx-a.png"
                width="20"
                style="position: absolute; right: 5px; top: 5px"
              />
              <div
                style="
                  position: absolute;
                  text-align: center;
                  bottom: 5px;
                  width: 100%;
                  color: #ffffff !important;
                "
              >
                {{ item3.gameName }}
              </div>
            </div>
          </div>
          <!-- 没有数据时显示 -->
          <div
            class="t-c"
            style="margin-top: 20vh"
            v-if="favariteGames.length === 0"
          >
            <img src="../../../assets/img/common/img_no_data.png" width="90%" />
            <p class="font-color f-t-15 f-w">{{ $lang.common_txt145 }}</p>
          </div>
          <!-- 添加伪元素来模拟最后一个元素与前一个元素之间的间隔 -->
          <div class="spacer"></div>
        </div>
      </div>
    </div>
    <van-empty
      v-else-if="!loading"
      :description="$lang.common_txt145"
      class="category-empty"
    />
    <login v-model="showPopup" overlay></login>
  </div>
</template>
<script>
import { GetHomeGameList } from '@/api/common'
import { mapState, mapActions } from 'vuex'
import { favoriteItemsForCurrency, isFavoriteGame } from '@/store/favoritesStorage'
import {
  buildLaunchPayload,
  getVisibleGameGroups,
  isLaunchUnavailableToken,
  isUnavailableLaunchEntry,
  launchGame,
  normalizeHomeGameContent,
  toArray
} from '@/components/home/gameLaunch'
import {
  gameResponseBody,
  isHomeGameReadableResponse
} from '@/views/details/home/gameResponse'

const HOME_CATEGORY_LIST_KEYS = [
  'dataList',
  'list',
  'gameList',
  'game_list',
  'allGameList',
  'records',
  'items',
  'categoryList',
  'categories',
  'games'
]
const HOME_CATEGORY_NESTED_LIST_KEYS = [
  'category',
  'categories',
  'game',
  'games',
  'page',
  'pageInfo',
  'result',
  'payload',
  'data',
  'body',
  'content',
  'extra'
]
const HOME_CATEGORY_DIAGNOSTIC_KEYS = [
  'meta',
  'diagnostics',
  'diagnostic',
  'detail',
  'details',
  'error',
  'errors'
]
const HOME_CATEGORY_RESPONSE_SCAN_KEYS = [
  ...HOME_CATEGORY_NESTED_LIST_KEYS,
  ...HOME_CATEGORY_DIAGNOSTIC_KEYS
]
const HOME_CATEGORY_ID_KEYS = [
  'gid',
  'gameId',
  'game_id',
  'favoriteId',
  'favorite_id',
  'launchId',
  'launch_id'
]
const HOME_CATEGORY_PROOF_KEYS = [
  'writeProof',
  'write_proof',
  'paymentUrlProof',
  'payment_url_proof',
  'launchProof',
  'launch_proof',
  'favoriteProof',
  'favorite_proof',
  'proof',
  'proofId',
  'proof_id',
  'affectedRowsProof',
  'affected_rows_proof'
]
const HOME_CATEGORY_FLAG_KEYS = [
  'falseProof',
  'false_proof',
  'failClosed',
  'fail_closed',
  'placeholder',
  'routeUnavailable',
  'route_unavailable',
  'readFailure',
  'read_failure',
  'readFailed',
  'read_failed',
  'readUnavailable',
  'read_unavailable',
  'technicalMarker',
  'technical_marker',
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'backendFailure',
  'backend_failure',
  'notConnected',
  'not_connected',
  'readOnlyMode',
  'read_only_mode',
  'mockMode',
  'mock_mode'
]
const HOME_CATEGORY_RESPONSE_BLOCK_KEYS = [
  ...HOME_CATEGORY_FLAG_KEYS,
  'backendBlocked',
  'backend_blocked',
  'actionBlocked',
  'action_blocked',
  'writeBlocked',
  'write_blocked',
  'blocked',
  'block',
  'needLogin',
  'need_login'
]
const HOME_CATEGORY_URL_KEYS = [
  'forwardUrl',
  'forward_url',
  'url',
  'gameUrl',
  'game_url',
  'launchUrl',
  'launch_url',
  'playUrl',
  'play_url',
  'redirectUrl',
  'redirect_url',
  'iframeUrl',
  'iframe_url'
]
const HOME_CATEGORY_TEXT_MARKER_KEYS = [
  'status',
  'state',
  'result',
  'code',
  'errorCode',
  'launchStatus',
  'forwardStatus'
]

function homeCategoryObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {}
}

function homeCategoryToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function hasHomeCategoryKey(source, key) {
  return Object.prototype.hasOwnProperty.call(source, key)
}

function isHomeCategoryFalseProof(value) {
  if (value === false || value === 0) return true
  return ['false', '0', 'no', 'off'].includes(homeCategoryToken(value))
}

function isHomeCategoryActiveBlock(value) {
  const token = homeCategoryToken(value)
  if (value === true || value === 1) return true
  return ['true', '1', 'yes', 'on'].includes(token) ||
    token.includes('placeholder') ||
    token.includes('fail_closed') ||
    token.includes('fail-closed') ||
    token.includes('fail closed') ||
    token.includes('failclosed') ||
    token.includes('technicalmarker') ||
    token.includes('technical_marker') ||
    token.includes('backendfailure') ||
    token.includes('backend_failure') ||
    isLaunchUnavailableToken(value)
}

function isUnsafeHomeCategoryUrl(value) {
  const url = String(value == null ? '' : value).trim()
  if (!url) return true
  if (/^https?:\/\//i.test(url)) return false
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return true
  return isLaunchUnavailableToken(url)
}

function isUnsafeHomeCategoryLayer(layer) {
  return HOME_CATEGORY_RESPONSE_BLOCK_KEYS.some((key) => hasHomeCategoryKey(layer, key) && isHomeCategoryActiveBlock(layer[key])) ||
    HOME_CATEGORY_TEXT_MARKER_KEYS.some((key) => hasHomeCategoryKey(layer, key) && isHomeCategoryActiveBlock(layer[key])) ||
    HOME_CATEGORY_PROOF_KEYS.some((key) => hasHomeCategoryKey(layer, key) && (isHomeCategoryFalseProof(layer[key]) || isLaunchUnavailableToken(layer[key]))) ||
    HOME_CATEGORY_URL_KEYS.some((key) => hasHomeCategoryKey(layer, key) && isUnsafeHomeCategoryUrl(layer[key]))
}

function hasUnsafeHomeCategoryDiagnostics(item) {
  return HOME_CATEGORY_DIAGNOSTIC_KEYS.some((key) => {
    const nested = item[key]
    if (!nested || (typeof nested !== 'object' && !Array.isArray(nested))) return false
    return collectHomeCategoryResponseLayers(nested, 0, [], [], true).some(isUnsafeHomeCategoryLayer)
  })
}

function isUnsafeHomeCategoryEntry(entry) {
  const item = homeCategoryObject(entry)
  if (!Object.keys(item).length) return false
  if (isUnavailableLaunchEntry(item)) return true
  if (HOME_CATEGORY_FLAG_KEYS.some((key) => hasHomeCategoryKey(item, key) && isHomeCategoryActiveBlock(item[key]))) return true
  if (HOME_CATEGORY_PROOF_KEYS.some((key) => hasHomeCategoryKey(item, key) && (isHomeCategoryFalseProof(item[key]) || isLaunchUnavailableToken(item[key])))) return true
  if (HOME_CATEGORY_ID_KEYS.some((key) => hasHomeCategoryKey(item, key) && isLaunchUnavailableToken(item[key]))) return true
  if (HOME_CATEGORY_URL_KEYS.some((key) => hasHomeCategoryKey(item, key) && isUnsafeHomeCategoryUrl(item[key]))) return true
  return hasUnsafeHomeCategoryDiagnostics(item)
}

function firstHomeCategoryList(source, depth = 0, seen = []) {
  if (Array.isArray(source)) return source
  if (!source || typeof source !== 'object' || depth >= 8 || seen.includes(source)) return null
  seen.push(source)
  for (const key of HOME_CATEGORY_LIST_KEYS) {
    if (Array.isArray(source[key])) return source[key]
  }
  for (const key of HOME_CATEGORY_NESTED_LIST_KEYS) {
    const nested = source[key]
    if (!nested || typeof nested !== 'object') continue
    const list = firstHomeCategoryList(nested, depth + 1, seen)
    if (Array.isArray(list)) return list
  }
  return null
}

function homeCategoryContentWithList(content) {
  const base = homeCategoryObject(content)
  if (HOME_CATEGORY_LIST_KEYS.some((key) => Array.isArray(base[key]))) return base
  const list = firstHomeCategoryList(base)
  return Array.isArray(list) ? { ...base, dataList: list } : base
}

function collectHomeCategoryResponseLayers(source, depth = 0, out = [], seen = [], scanDiagnosticTree = false) {
  const body = homeCategoryObject(source)
  if (!Object.keys(body).length || depth >= 8 || seen.includes(source)) return out
  seen.push(source)
  out.push(body)
  const keys = scanDiagnosticTree ? Object.keys(body) : HOME_CATEGORY_RESPONSE_SCAN_KEYS
  for (const key of keys) {
    const nested = body[key]
    if (!nested || (typeof nested !== 'object' && !Array.isArray(nested))) continue
    if (Array.isArray(nested)) {
      nested.forEach((item) => collectHomeCategoryResponseLayers(
        item,
        depth + 1,
        out,
        seen,
        scanDiagnosticTree || HOME_CATEGORY_DIAGNOSTIC_KEYS.includes(key)
      ))
      continue
    }
    collectHomeCategoryResponseLayers(
      nested,
      depth + 1,
      out,
      seen,
      scanDiagnosticTree || HOME_CATEGORY_DIAGNOSTIC_KEYS.includes(key)
    )
  }
  return out
}

function isHomeCategorySuccessToken(value) {
  if (value === true || value === 0 || value === 200) return true
  return ['ok', 'success', 'successful', 'succeeded', '0', '00', '0000', '200'].includes(homeCategoryToken(value))
}

function hasHomeCategorySuccessMarker(source) {
  return collectHomeCategoryResponseLayers(source).some((layer) =>
    [layer.status, layer.state, layer.result, layer.code, layer.errorCode, layer.success].some(isHomeCategorySuccessToken)
  )
}

function hasHomeCategoryResponseBlock(source) {
  return collectHomeCategoryResponseLayers(source).some((layer) => {
    if (layer.success === false || homeCategoryToken(layer.success) === 'false') return true
    if (HOME_CATEGORY_RESPONSE_BLOCK_KEYS.some((key) => hasHomeCategoryKey(layer, key) && isHomeCategoryActiveBlock(layer[key]))) return true
    if (HOME_CATEGORY_TEXT_MARKER_KEYS.some((key) => hasHomeCategoryKey(layer, key) && isHomeCategoryActiveBlock(layer[key]))) return true
    return HOME_CATEGORY_PROOF_KEYS.some((key) => hasHomeCategoryKey(layer, key) && (isHomeCategoryFalseProof(layer[key]) || isLaunchUnavailableToken(layer[key])))
  })
}

function isReadableHomeCategoryResponse(response) {
  if (!Array.isArray(firstHomeCategoryList(response))) return false
  if (!hasHomeCategorySuccessMarker(response)) return false
  return !hasHomeCategoryResponseBlock(response)
}

function homeCategoryResponseBody(response) {
  if (typeof gameResponseBody === 'function') return gameResponseBody(response)
  return homeCategoryContentWithList(response)
}

function sanitizeHomeCategoryType(type) {
  const safeType = homeCategoryObject(type)
  if (!Object.keys(safeType).length || isUnsafeHomeCategoryEntry(safeType)) return null
  return {
    ...safeType,
    games: toArray(safeType.games).filter((game) => !isUnsafeHomeCategoryEntry(game))
  }
}

function sanitizeHomeCategoryGroup(group) {
  const safeGroup = homeCategoryObject(group)
  if (!Object.keys(safeGroup).length || isUnsafeHomeCategoryEntry(safeGroup)) return null
  return {
    ...safeGroup,
    types: toArray(safeGroup.types)
      .map(sanitizeHomeCategoryType)
      .filter(Boolean)
  }
}

function normalizeSafeHomeCategoryContent(content) {
  const normalized = normalizeHomeGameContent(homeCategoryContentWithList(content))
  return {
    ...normalized,
    dataList: toArray(normalized.dataList)
      .map(sanitizeHomeCategoryGroup)
      .filter(Boolean)
  }
}

export default {
  name: 'Category',
  components: {},
  data() {
    return {
      gameValue: '',
      pgDate: {},
      dataList: [],
      selectIndex: 0,
      selectIndex2: 0,
      showPopup: false,
      loading: false,
      categoryReadError: '',
      favariteGames: [],
      seachArr: [],
      allGames: []
    }
  },
  watch: {
    gameValue(value) {
      if (value.length > 0) {
        this.selectIndex2 = 0
      }
      const item = this.dataList[this.selectIndex]
      if (!item || !Array.isArray(item.types)) {
        this.allGames = []
        return
      }
      let newArr = toArray(item.types).reduce((acc, type) => {
        return acc.concat(toArray(type && type.games))
      }, [])
      this.allGames = newArr.filter((i) =>
        (i.gameName || '').toLowerCase().includes(this.gameValue.toLowerCase())
      )
    }
  },
  computed: {
    ...mapState(['favorites'])
    // 新增：获取当前币种
    // currentCurrency() {
    //   return this.getCurrency // 确保getCurrency方法/属性已定义
    // }
  },
  created() {},
  mounted() {
    this.GetHomeGameList()
  },
  methods: {
    ...mapActions(['addFavorite', 'removeFavorite']),
    // 修改：适配分组结构的收藏判断逻辑
    isFavorite(item) {
      return isFavoriteGame(this.favorites, this.getCurrency, item)
    },
    // 修改：适配分组结构的收藏切换逻辑
    toggleFavorite(item) {
      if (!this.token) {
        this.showPopup = true
        return
      }
      if (isUnsafeHomeCategoryEntry(item)) {
        this.$toast({
          message: this.$lang.common_txt145,
          icon: 'cross'
        })
        return
      }
      // 构造payload，包含当前currency和游戏项
      const payload = {
        currency: this.getCurrency,
        item: item
      }
      if (this.isFavorite(item)) {
        this.removeFavorite(payload)
      } else {
        this.addFavorite(payload)
      }
      // 切换收藏后更新收藏列表展示
      if (this.selectIndex2 === 1) {
        this.getSelect2(1)
      }
    },
    onClickLeft() {
      this.$jumpTo('/home', {}, { replace: true })
    },
    goToGame(v, v2) {
      if (this.categoryReadError) {
        this.$toast({
          message: this.categoryReadError,
          icon: 'cross'
        })
        return
      }
      if (this.token) {
        const game = v2 || (v && typeof v === 'object' ? v : null)
        if (isUnsafeHomeCategoryEntry(game)) {
          this.$toast({
            message: this.$lang.common_txt145,
            icon: 'cross'
          })
          return
        }
        const jumpPayload = buildLaunchPayload(game, {
          isDemo: this.$route.query.isDemo || this.$route.query.demo,
          typeCate: 1,
          gameTab: this.$route.query.gameTab,
          typeCode: game && (game.typeCode || game.code)
        })
        if (!jumpPayload) {
          this.$toast({
            message: this.$lang.common_txt145,
            icon: 'cross'
          })
          return
        }
        launchGame(this, jumpPayload)
      } else {
        this.showPopup = true
      }
    },
    getSelect(v) {
      this.selectIndex = v
      const item = this.dataList[v]
      if (!item || !Array.isArray(item.types)) {
        this.allGames = []
        return
      }
      let newArr = toArray(item.types).reduce((acc, type) => {
        return acc.concat(toArray(type && type.games))
      }, [])

      if (this.gameValue.length > 0) {
        this.allGames = newArr.filter((i) =>
          (i.gameName || '').toLowerCase().includes(this.gameValue.toLowerCase())
        )
      } else {
        this.allGames = newArr
      }
      this.$nextTick(() => {
        if (this.$refs.targetElement) {
          this.$refs.targetElement.scrollTop = 0
        }
      })
    },
    // 修改：获取收藏列表时只展示当前币种下的收藏游戏
    getSelect2(v) {
      this.selectIndex2 = v
      if (v === 1) {
        this.favariteGames = favoriteItemsForCurrency(this.favorites, this.getCurrency)
          .filter((game) => !isUnsafeHomeCategoryEntry(game))
        this.gameValue = ''
      }
      this.$nextTick(() => {
        if (this.$refs.targetElement) {
          this.$refs.targetElement.scrollTop = 0
        }
      })
    },
    clearHomeCategoryReadState() {
      this.pgDate = {}
      this.dataList.splice(0, this.dataList.length)
      this.allGames.splice(0, this.allGames.length)
      this.favariteGames.splice(0, this.favariteGames.length)
      this.seachArr.splice(0, this.seachArr.length)
      this.selectIndex = 0
      this.selectIndex2 = 0
    },
    async GetHomeGameList() {
      // partCode（分类码）和 vendorCode（厂商码）都是 types[].code，语义一致，任取其一
      const typeCode =
        this.$route.query.partCode ||
        this.$route.query.vendorCode ||
        this.$route.query.typeCode
      this.loading = true
      try {
        const data = await GetHomeGameList()
        const gameGuardReadable =
          typeof isHomeGameReadableResponse === 'function' &&
          isHomeGameReadableResponse(data) &&
          !hasHomeCategoryResponseBlock(data)
        if (gameGuardReadable || isReadableHomeCategoryResponse(data)) {
          const normalized = normalizeSafeHomeCategoryContent(homeCategoryResponseBody(data))
          this.pgDate = normalized
          // 后端返回全部分类，前端按 code 过滤 types 层级
          const visibleList = getVisibleGameGroups(normalized, this.getCurrency)
          const filteredList = typeCode
            ? visibleList
                .map((it) => ({
                  ...it,
                  types: toArray(it.types).filter(
                    (t) => String(t && t.code) === String(typeCode)
                  )
                }))
                .filter((it) => it.types.length > 0)
            : visibleList

          // 使用 map 和 reduce 合并 types 数组
          const typesArr = filteredList
            .map((item) => toArray(item.types))
            .reduce((acc, current) => acc.concat(current), [])

          const newList = [
            {
              name: 'Lobby',
              icon: require('@/assets/img/common/all_home.png'),
              types: typesArr
            },
            ...filteredList.map((it) => ({
              ...it,
              types: toArray(it.types)
            }))
          ]
          this.dataList.splice(0, this.dataList.length, ...newList) // 替换原数组
          this.categoryReadError = ''

          this.dataList.forEach((i) => {
            if (Array.isArray(i.types)) {
              i.types.sort((a, b) => (a.order || 0) - (b.order || 0))
            }
          })

          let newArr = toArray(this.dataList[0] && this.dataList[0].types).filter(
            (i) => i.code === '3000602'
          )
          this.isOtgame = newArr.flatMap((item) =>
            toArray(item.games).filter((game) => game.gameName === 'Lucky Ball')
          )
          if (this.dataList[0]) {
            this.dataList[0].homeIcon = require('@/assets/img/common/all_home.png')
          }
          const tab = parseInt(this.$route.query.gameTab, 10)
          const safeTab =
            !isNaN(tab) && tab >= 0 && tab < this.dataList.length ? tab : 0
          this.selectIndex = safeTab
          this.getSelect(safeTab)
        } else {
          this.clearHomeCategoryReadState()
          this.categoryReadError = '游戏列表暂不可用，请稍后重试'
        }
      } catch (_) {
        this.clearHomeCategoryReadState()
        this.categoryReadError = '游戏列表加载失败，请稍后重试'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
.cot-Search {
  width: 100%;
  max-width: var(--vk-pc-col);
  position: fixed;
  // background: @cont-bg;
  padding: 5px 7px;
  // .custom-field {
  //   background: #2d2456 !important;
  // }
}
.category-read-error {
  position: fixed;
  top: 100px;
  left: 7px;
  right: 7px;
  z-index: 20;
  max-width: 436px;
  margin: 0 auto;
  padding: 8px 10px;
  border-radius: 6px;
  background: rgba(255, 193, 7, 0.12);
  color: #ffd36a;
  font-size: var(--vk-fs-xs);
  line-height: 1.4;
}
.cot-cont {
  display: flex;
  margin-top: 65px;
  .cot-cont-l {
    display: flex;
    flex-flow: column;
    position: fixed;
    overflow-y: scroll;
    max-height: 82vh;
    padding-bottom: 50px;
    .cot-cont-li {
      // font-weight: bold;
      text-align: center;
      background: @cont-bg;
      border-radius: 8px;
      margin: 0 10px 12px 10px;
      padding: 5px 10px;
      color: #ffffff;
      cursor: pointer;
      max-width: 66px;
      font-size: var(--vk-fs-xs);
    }
  }
}
.active-select {
  // background-image: linear-gradient(99deg, #ffaf00 0%, #ff5a1f 85%) !important;
  background: #4080ff !important;
  box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.15);
  color: #ffffff !important;
}
.active-select2 {
  // background-image: linear-gradient(99deg, #ffaf00 0%, #ff5a1f 85%) !important;
  background: #4080ff !important;
  box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.15);
  color: #ffffff !important;
}
.cot-cont-r {
  position: fixed;
  margin-left: 0;
  width: 100%;
}
.cot-cont-rt {
  position: fixed;
  display: flex;
  align-items: center;
  background: transparent;
  margin-left: 10px;
  // width: 100%;
  // max-width: 365px;
  .cot-cont-rti {
    background: @cont-bg;
    color: #ffffff;
    border-radius: 6px;
    text-align: center;
    min-width: 70px;
    padding: 8px 0;
    margin-right: 10px;
    cursor: pointer;
  }
}
.cot-cont-rb {
  margin-top: 45px;
  width: 100%;
  flex-flow: wrap row;
  overflow-y: scroll;
  max-height: 78vh;
  max-width: var(--vk-pc-col);
  padding: 0 7px 50px;
}
.cot-cont-rbi {
  width: 31.5%;
  margin-bottom: 5px;
  position: relative;
  max-height: 125px;
}
.cot-cont-rb > div:last-child {
  margin-right: 31.5%; /* 或者padding-right */
}
::v-deep .van-loading__spinner {
  display: none;
}
::v-deep .van-image__img {
  border-radius: 13px !important;
  max-height: 125px;
}
</style>
